function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fill: "#073C50",
  fillRule: "evenodd",
  d: "M34.1766235,5.82337649 C40.972989,12.619742 41.820411,23.112307 36.7188894,30.8304124 L48.3502166,42.4617316 L42.7266668,48.0852814 L31.1009585,36.4601718 C23.3795954,41.5874661 12.865533,40.747784 6.0588745,33.9411255 C-1.70562748,26.1766235 -1.70562748,13.5878785 6.0588745,5.82337649 C13.8233765,-1.9411255 26.4121215,-1.9411255 34.1766235,5.82337649 Z M11.6824243,11.4469263 C7.02372311,16.1056275 7.02372311,23.6588745 11.6824243,28.3175757 C16.3411255,32.9762769 23.8943725,32.9762769 28.5530737,28.3175757 C33.2117749,23.6588745 33.2117749,16.1056275 28.5530737,11.4469263 C23.8943725,6.7882251 16.3411255,6.7882251 11.6824243,11.4469263 Z"
});

var SvgSearch = function SvgSearch(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgSearch, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Search.c556c0c9.svg";
export { ForwardRef as ReactComponent };